import { store } from '@/store/store'

export const requestBody = {

  getRequestBody ({ methodName, methodParameters }) {
    methodParameters = JSON.parse(JSON.stringify(methodParameters))
    if (this[methodName + 'RequestBody']) {
      return this[methodName + 'RequestBody']({ methodParameters })
    } else {
      return methodParameters
    }
  },

  bootstrapRequestBody ({ methodParameters }) {
    console.log('[START] - Bootstraping Aggregator SDK for below networks')
    console.table(methodParameters)
    return {
      sdkConfigs: methodParameters
    }
  },

  initRequestBody ({ methodParameters }) {
    let { sdkSpecificParameters } = methodParameters
    let merchantName = store.getters.dpaId.displayDpaName
    delete methodParameters.dpaTransactionOptions.consumerNationalIdentifierRequested
    methodParameters.dpaTransactionOptions['threeDsPreference'] = store.getters.threeDSPreference ? store.getters.threeDSPreference : 'NONE'
    this.setCustomInputData(methodParameters)

    if (sdkSpecificParameters.mastercard) {
      delete sdkSpecificParameters.mastercard.dpaTransactionOptions.payloadTypeIndicator
      delete sdkSpecificParameters.mastercard.dpaTransactionOptions.paymentOptions.dpaPanRequested
      delete sdkSpecificParameters.mastercard.host
      sdkSpecificParameters.mastercard.dpaData = { dpaPresentationName: merchantName, dpaName: merchantName }
      sdkSpecificParameters.mastercard.dpaTransactionOptions.isGuestCheckout = false
      if (sdkSpecificParameters.mastercard.dpaTransactionOptions.paymentOptions[0].dynamicDataType === '') {
        sdkSpecificParameters.mastercard.dpaTransactionOptions.paymentOptions[0].dynamicDataType = 'NONE'
      }
    }

    if (sdkSpecificParameters.visa) {
      delete sdkSpecificParameters.visa.dpaTransactionOptions.payloadTypeIndicatorCheckout
      delete sdkSpecificParameters.visa.dpaTransactionOptions.payloadTypeIndicatorPayload
      delete sdkSpecificParameters.visa.host
      sdkSpecificParameters.visa.dpaData = { dpaPresentationName: merchantName, dpaName: merchantName }
      if (sdkSpecificParameters.visa.dpaTransactionOptions.paymentOptions[0].dynamicDataType === 'DTVV') {
        sdkSpecificParameters.visa.dpaTransactionOptions.paymentOptions[0].dynamicDataType = 'DYNAMIC_CARD_SECURITY_CODE'
      } else if (sdkSpecificParameters.visa.dpaTransactionOptions.paymentOptions[0].dynamicDataType === 'TAVV') {
        sdkSpecificParameters.visa.dpaTransactionOptions.paymentOptions[0].dynamicDataType = 'CARD_APPLICATION_CRYPTOGRAM_SHORT_FORM'
      }
    }

    if (sdkSpecificParameters.amex) {
      delete sdkSpecificParameters.amex.dpaTransactionOptions.payloadTypeIndicatorCheckout
      delete sdkSpecificParameters.amex.dpaTransactionOptions.payloadTypeIndicatorPayload
      delete sdkSpecificParameters.amex.dpaTransactionOptions.paymentOptions.dpaDynamicDataTtlMinutes
      delete sdkSpecificParameters.amex.host
      sdkSpecificParameters.amex.dpaData = { dpaPresentationName: merchantName, dpaName: merchantName }
      sdkSpecificParameters.amex.dpaTransactionOptions.isGuestCheckout = false
      sdkSpecificParameters.amex.dpaTransactionOptions.paymentOptions[0].dynamicDataType = 'DYNAMIC_CARD_SECURITY_CODE'
    }

    if (sdkSpecificParameters.discover) {
      delete sdkSpecificParameters.discover.dpaTransactionOptions.payloadTypeIndicator
      delete sdkSpecificParameters.discover.dpaTransactionOptions.paymentOptions.dpaPanRequested
      delete sdkSpecificParameters.discover.host
      if (sdkSpecificParameters.discover.dpaTransactionOptions.paymentOptions[0].dynamicDataType === '') {
        sdkSpecificParameters.discover.dpaTransactionOptions.paymentOptions[0].dynamicDataType = 'NONE'
      }
    }
    return methodParameters
  },

  isRecognizedRequestBody ({ methodParameters }) {
    let recognitionToken = store.getters.recognitionToken
    let environment = store.getters.environment
    if (recognitionToken[environment]) {
      methodParameters['recognitionTokens'] = [recognitionToken[environment]]
    }
    return methodParameters
  },

  identityLookupRequestBody ({ methodParameters }) {
    if (methodParameters.consumerIdentity.identityType === 'MOBILE_PHONE_NUMBER') {
      let { mobileNumber } = methodParameters.consumerIdentity.identityValue
      methodParameters.consumerIdentity.identityValue = mobileNumber.countryCode + '' + mobileNumber.phoneNumber
    } else {
      methodParameters.consumerIdentity.identityValue = methodParameters.consumerIdentity.identityValue.email
    }
    return methodParameters
  },

  initiateIdentityValidationRequestBody ({ methodParameters }) {
    if (store.getters.validationData.network === 'mastercard') {
      let validationChannelId = methodParameters['requestedValidationChannelId']
      // eslint-disable-next-line
      let regex = /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/
      if (regex.test(validationChannelId)) {
        return {
          requestedValidationChannelId: 'EMAIL_ADDRESS'
        }
      } else {
        return {
          requestedValidationChannelId: 'MOBILE_PHONE_NUMBER'
        }
      }
    } else {
      return {}
    }
  },

  completeIdentityValidationRequestBody ({ methodParameters }) {
    let complianceSettings
    let appInstance
    if (store.getters.rememberMe && store.getters.complianceSettingsObj.complianceResources) {
      complianceSettings = {
        ...store.getters.complianceSettingsObj,
        complianceResources: store.getters.complianceSettingsObj.complianceResources.map(res => ({ ...res, complianceType: 'REMEMBER_ME' }))
      }
      appInstance = {
        userAgent: window.navigator.userAgent
      }
      delete complianceSettings.privacy
      delete complianceSettings.tnc
      delete complianceSettings.cookie
      return { ...methodParameters, complianceSettings, appInstance }
    }

    return { ...methodParameters }
  },

  unbindAppInstanceRequestBody ({ methodParameters }) {
    let recognitionToken = store.getters.recognitionToken
    let environment = store.getters.environment
    if (recognitionToken[environment]) {
      methodParameters['recognitionToken'] = recognitionToken[environment]
    }
    return methodParameters
  },

  checkoutRequestBody ({ methodParameters }) {
    delete methodParameters.network
    delete methodParameters.dpaData
    delete methodParameters.dpaTransactionOptions.consumerNationalIdentifierRequested
    delete methodParameters.sdkSpecificDpaTransactionOptions
    delete methodParameters.idToken
    methodParameters.dpaTransactionOptions['threeDsPreference'] = store.getters.threeDSPreference ? store.getters.threeDSPreference : 'NONE'
    this.setCustomInputData(methodParameters)
    let complianceSettings
    if (store.getters.rememberMe && store.getters.complianceSettingsObj.complianceResources) {
      complianceSettings = {
        ...store.getters.complianceSettingsObj,
        complianceResources: store.getters.complianceSettingsObj.complianceResources.map(res => ({ ...res, complianceType: 'REMEMBER_ME' }))
      }
    } else {
      complianceSettings = store.getters.complianceSettingsObj
    }
    methodParameters['complianceSettings'] = complianceSettings
    return {
      ...methodParameters
    }
  },

  setCustomInputData (methodParameters) {
    methodParameters.dpaTransactionOptions.customInputData = {
      ...methodParameters.dpaTransactionOptions.customInputData,
      'com.mastercard.acceptedCardBrands': [
        'mastercard',
        'maestro'
      ]
    }
  }
}
